module.exports = __webpack_public_path__ + "img/skillbk.fedf749a.png";